module.exports = __webpack_public_path__ + "assets/img/feather.8910cf04.png";